<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <router-link class="navbar-brand" to="/Home"><img src="../../assets/logo/BIMO_logo.svg" /></router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto">
          <li class="nav-item">
            <router-link class="nav-link"  to="/Home">Home</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link"  to="/tablets">Tablets</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link"  to="/players">Players</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link"  to="/groups">Groups</router-link>
          </li>
          <li class="nav-item">
            <button class="btn btn-light" @click="$emit('logout')">Logout</button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<style src="./nav-bar.component.scss" lang="scss" scoped></style>
